import {css, StyleSheet} from 'aphrodite';
import React, {CSSProperties} from 'react';

import {DragSelected} from 'search/blast/BLASTAlignmentSelectHelper';
import {SELECTED_OTHER_ROWS, SELECTED_ROW} from 'search/blast/BLASTAlignmentUtil';
import {NEAR_BLACK} from 'ui-library/Colors';

interface GraphDragZoomScreenProps {
  dragSelected: DragSelected;
  scale: number;
  totalLength: number;
  isQuery?: boolean;
}

export default function GraphDragZoomScreen(props: GraphDragZoomScreenProps): JSX.Element {
  const start = Math.round(props.dragSelected.residueStart * props.scale);
  const dragLeftBar: CSSProperties = {
    position: 'absolute',
    width: '2px',
    top: '-3px',
    bottom: '-3px',
    left: `${start}px`,
    zIndex: 2,
    backgroundColor: NEAR_BLACK,
  };

  if (!props.dragSelected.residueEnd) {
    return (
      <>
        {props.isQuery && <SVGAndTriangle x={start + 1} y={0} totalLength={props.totalLength} />}
        <div style={dragLeftBar} />
      </>
    );
  }

  const end = Math.round(props.dragSelected.residueEnd * props.scale);
  const dragSelected: CSSProperties = {
    position: 'absolute',
    width: `${end - start}px`,
    top: '-1px',
    bottom: '-1px',
    left: `${start}px`,
    zIndex: -1,
    backgroundColor: props.dragSelected.rowSelected ? SELECTED_ROW : SELECTED_OTHER_ROWS,
  };
  const dragRightBar: CSSProperties = {
    position: 'absolute',
    width: '2px',
    top: '-3px',
    bottom: '-3px',
    left: `${end}px`,
    zIndex: 2,
    backgroundColor: NEAR_BLACK,
  };

  return (
    <>
      {props.isQuery && <SVGAndTriangle x={start + 1} y={0} totalLength={props.totalLength} />}
      <div style={dragLeftBar} />
      {!props.isQuery && <div style={dragSelected} />}
      {props.isQuery && <SVGAndTriangle x={end + 1} y={0} totalLength={props.totalLength} />}
      <div style={dragRightBar} />
    </>
  );
}

function SVGAndTriangle({x, y, totalLength}: {x: number; y: number; totalLength: number}): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={totalLength}
      height={1000}
      fill="none"
      className={css(styles.svg)}
    >
      <Triangle x={x} y={y} />
    </svg>
  );
}

export function Triangle({x, y}: {x: number; y: number}): JSX.Element {
  const sideLength = 12;
  const points = [
    {x: x - sideLength / 2, y}, // Top left point
    {x: x + sideLength / 2, y}, // Top right point
    {x, y: y + (sideLength * Math.sqrt(3)) / 2}, // Bottom point
  ];
  const pointString = points.map((point) => `${point.x},${point.y}`).join(' ');
  return <polygon points={pointString} fill="black" />;
}

const styles = StyleSheet.create({
  svg: {
    position: 'absolute',
    zIndex: 99,
    top: 0,
    shapeRendering: 'crispEdges',
  },
});
